// extracted by mini-css-extract-plugin
export default {"iconGreen":"Reviews_iconGreen__4M7zT","iconRed":"Reviews_iconRed__7fmPa"};